export default __webpack_public_path__ + "static/media/img_success_1.b41788dd.png";